import Row from "./Row";

const Column = ({ block, page, ...props }) => {
  return <Row isColumn block={block} page={page} {...props} />;
};

export default Column;
